/* sb-dc-varfix.js - 2026-08-31, paging fix 2026-09-01

   Shopify's /products/<handle>.js returns at most 250 variants. Several of our
   products carry far more (custom-vinyl-banners has 637, window-decals 570), so
   the design center's variant lookup found nothing for any size past that cut -
   including the default 8x4 ft banner. The add-to-cart then ended in
   "resolved false" and the customer saw a button that simply did nothing.

   Two things happen here:

   1. fetch is wrapped. When a /products/<handle>.js response comes back with
      the tell-tale 250 variants, the complete list is pulled from Supabase
      (table dc_variants, seeded from the Admin API) and spliced into the JSON
      before the app ever sees it. Everything downstream keeps working the way
      it always did - it just gets the whole catalogue now.

   2. If a request to /cart/add.js comes back failed, the customer is told so.
      Silence was the worst part of this bug: designs were finished and then
      abandoned at the cart step.

      2026-09-05 - the second half of this went away. There used to be a
      12-second timer that also spoke up when an add ended with no request to
      /cart/add.js at all. It fired long after the customer had given up and
      looked at something else, and it was the third red box for one failure
      (the proof panel's own .sbdc-cart-err and, on a size mismatch,
      sb-dc-sizeguard.js's banner). The case it covered - the variant lookup
      dying before the cart was ever called - is what sb-dc-retry.js now
      retries, and the proof panel says so on the spot either way.

   2026-09-01 - the pages have to be emptied, not just page 1 filled.

   The app walks the pages itself: .js, then ?page=2, then ?page=3, and
   concatenates what comes back. The regex below matches every one of those,
   so page 1 AND page 2 were each handed the complete 637-variant list, and
   page 3 added its own real 137 on top - 1411 entries for 637 sizes, every
   size present twice. The variant lookup then found two matches for one size
   and refused to choose, and the customer was told "This size cannot be
   added" (detail: "Several packages share this size..."). It hit every size
   on these products, not just the large ones.

   So: page 1 gets the full list, and every later page of that same handle
   comes back with an empty variants array - page 1 already carried them all.
   Later pages are only emptied for a handle we actually spliced; if the
   response was never truncated, paging is left exactly as it was.

   Load this BEFORE the other design-center scripts. sb-dc-retry.js is the one
   thing that goes in front of it - the retrying has to finish underneath this
   wrapper so a 429 that succeeds on the second try is never seen here as a
   failure. */
(function () {
  var SB = 'https://uktrkymhgmzlufzxsavf.supabase.co/rest/v1/dc_variants';
  var KEY = 'sb_publishable_6_IwzTvtBpQRo4ZabzRyOA_wAHEDZA2';
  var TRUNCATED_AT = 250;
  var realFetch = window.fetch.bind(window);
  var cache = {};
  var spliced = {};

  function fullVariants(handle) {
    if (cache[handle]) return cache[handle];
    var url = SB + '?handle=eq.' + encodeURIComponent(handle) +
      '&select=okey,variant_id,price,available&limit=5000';
    cache[handle] = realFetch(url, {
      headers: { apikey: KEY, Authorization: 'Bearer ' + KEY }
    }).then(function (r) {
      return r.ok ? r.json() : [];
    }).catch(function () {
      return [];
    });
    return cache[handle];
  }

  /* Rebuild each variant off a real one from the response, so every field the
     theme or the app might read (requires_shipping, taxable, barcode, ...) is
     still there and only the identifying bits change. */
  function build(rows, sample) {
    var base = String(sample.name || '');
    var dash = base.lastIndexOf(' - ');
    var productName = dash > -1 ? base.slice(0, dash) : base;
    return rows.map(function (row) {
      var opts = String(row.okey).split('|');
      var v = {};
      for (var k in sample) v[k] = sample[k];
      v.id = row.variant_id;
      v.options = opts;
      v.option1 = opts[0] != null ? opts[0] : null;
      v.option2 = opts[1] != null ? opts[1] : null;
      v.option3 = opts[2] != null ? opts[2] : null;
      v.title = opts.join(' / ');
      v.public_title = v.title;
      v.name = productName ? productName + ' - ' + v.title : v.title;
      v.price = Math.round(Number(row.price || 0) * 100);
      v.available = row.available !== false;
      v.featured_image = null;
      return v;
    });
  }

  function json(payload) {
    return new Response(JSON.stringify(payload), {
      status: 200,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  function notify(msg) {
    try {
      var id = 'sb-dc-varfix-note';
      var el = document.getElementById(id);
      if (!el) {
        el = document.createElement('div');
        el.id = id;
        el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);' +
          'z-index:2147483647;max-width:min(560px,92vw);background:#b3261e;color:#fff;' +
          'font:600 14px/1.45 Archivo,system-ui,sans-serif;padding:14px 18px;border-radius:10px;' +
          'box-shadow:0 8px 28px rgba(0,0,0,.28);cursor:pointer';
        el.addEventListener('click', function () { el.remove(); });
        document.body.appendChild(el);
      }
      el.textContent = msg;
      setTimeout(function () { if (el && el.parentNode) el.remove(); }, 15000);
    } catch (e) { /* never let the notice break the page */ }
  }

  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var call = realFetch.apply(null, arguments);

    if (url.indexOf('/cart/add') > -1) {
      return call.then(function (res) {
        if (!res.ok) {
          notify('We could not add this design to your cart. Please try again, or call 1-855-622-7272 and we will place the order for you.');
        }
        return res;
      });
    }

    var m = /\/products\/([^/?#]+)\.js(\?|$)/.exec(url);
    if (!m) return call;
    var handle = m[1];
    var pageM = /[?&]page=(\d+)/.exec(url);
    var page = pageM ? parseInt(pageM[1], 10) : 1;

    return call.then(function (res) {
      if (!res.ok) return res;
      return res.clone().json().then(function (p) {
        if (!p || !p.variants) return res;

        /* A later page of a handle whose page 1 we already completed. Handing
           its variants over as well would list every size twice. */
        if (page > 1) {
          if (!spliced[handle]) return res;
          p.variants = [];
          return json(p);
        }

        if (p.variants.length < TRUNCATED_AT) return res;
        return fullVariants(handle).then(function (rows) {
          if (!rows.length) return res;
          p.variants = build(rows, p.variants[0]);
          spliced[handle] = true;
          window.__dcVarfix = { handle: handle, count: p.variants.length };
          return json(p);
        });
      }).catch(function () { return res; });
    });
  };

})();
